import { Teaser as t } from '@xprog/prensa/types'

export const TeaserImageBottom: t.TeaserProps = {
  css: {
    mb: '$3',
    padding: '$0',
    width: '100%',
    '.TeaserSubtitle': {
      mb: '$3'
    },
    '.TeaserSubject': {
      mb: '$3'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase'
    },
    '.TeaserTitle': {
      mb: '$3'
    },
    '.TeaserTitleText': {
      color: '$basicBlackAlpha900'
    }
  },
  className: 'TeaserImageBottom',
  imageDerivative: '3x1',
  imageVariant: 'bottom',
  subjectBgColor: 'brandPrimary500',
  subjectColor: 'brandPrimary500',
  subtitleVariant: 'subtitle-default',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  titleVariant: 'newstitle-5xl'
}
